import React, { Component } from 'react';
import MetaTags from 'react-meta-tags';
import {
  Tab,
  Tabs,
  TabList,
  TabPanel,
} from 'react-tabs';
import { FaChevronRight, FaArrowUp } from 'react-icons/fa';
import { connect } from 'react-redux';
import { compose, graphql } from 'react-apollo';
import { billingDetails } from '../../queries';

import Reports from './Reports';
import Withdrawals from './Withdrawals';
import Loading from '../../components/Loading/Page';
import Footer from '../../components/Footer';

import { Content } from './styles';
import { Wrapper, Breadcrumb, ScrollTop } from '../../assets/styles';

class Billing extends Component {
  state = {
    breadcrumb: 'Relatórios',
    scrolling: false,
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    if (window.scrollY < 300 && this.state.scrolling === true) {
      this.setState({ scrolling: false });
    } else if (window.scrollY > 300 && this.state.scrolling !== true) {
      this.setState({ scrolling: true });
    }
  }

  scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }

  setBreadcrumb = (index) => {
    if (index === 0) {
      this.setState({ breadcrumb: 'Relatórios' });
    } else if (index === 1) {
      this.setState({ breadcrumb: 'Pagamentos' });
    }
  }

  render() {
    const { breadcrumb } = this.state;

    return (
      <div style={{ position: 'absolute', width: '100%' }}>
        <MetaTags>
          <title>Financeiro - Portal da Loja - Reforma Fácil</title>
          <meta name="robots" content="noindex" />
        </MetaTags>
        <Breadcrumb>
          <div className="container">
            <h2>Financeiro</h2>
            <FaChevronRight className="fas fa-chevron-right" />
            <h2 className="bold">{breadcrumb}</h2>
          </div>
        </Breadcrumb>
        <Wrapper>
          {this.props.data.loading && <Loading />}
          {!this.props.data.loading && (
            <Content roleType={this.props.store.roleType}>
              <Tabs className="tabs" defaultIndex={0} onSelect={index => this.setBreadcrumb(index)}>
                <div className="left">
                  <TabList>
                    <Tab>
                      <span className="required">Relatórios</span>
                    </Tab>
                    {this.props.store.roleType === 'owner' && (
                      <Tab>
                        <span className="required">Pagamentos</span>
                      </Tab>
                    )}
                  </TabList>
                </div>
                <div className="right">
                  <TabPanel>
                    <Reports
                      reports={this.props.data.billingDetailsPortal[0]}
                      storeId={this.props.store.id}
                    />
                  </TabPanel>
                  <TabPanel>
                    <Withdrawals
                      withdrawals={this.props.data.billingDetailsPortal[1]}
                      storeId={this.props.store.id}
                    />
                  </TabPanel>
                </div>
              </Tabs>
            </Content>
          )}
          <Footer />
        </Wrapper>
        {this.state.scrolling && (
          <ScrollTop onClick={this.scrollToTop}>
            <FaArrowUp className="fa fa-arrow-up" />
            <span>Topo</span>
          </ScrollTop>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  store: state.store,
});

export default compose(
  connect(mapStateToProps, null),
  graphql(billingDetails, {
    options: props => ({
      fetchPolicy: 'network-only',
      variables: { storeId: props.store.id },
    }),
  }),
)(Billing);
